import { Alert, Tag } from 'antd';
import { Skeleton } from '../../../../../shared/components/Skeleton';
import { SkeletonRegion } from '../../../../../shared/components/SkeletonRegion';
import { CROSSING_KIND_LABELS } from '../../../../../shared/policies/crossing-labels';
import { useTripCrossings } from '../hooks/use-trip-crossings';

/** What an opened trip row shows: where the truck arrived and left while on this trip. */
export function TripCrossings({ tripId }: { tripId: string }) {
  const state = useTripCrossings(tripId);
  if (state.status === 'loading') {
    return (
      <SkeletonRegion label="Loading arrivals and departures" className="flex flex-col gap-2">
        <Skeleton className="h-5 w-64" />
        <Skeleton className="h-5 w-64" />
      </SkeletonRegion>
    );
  }
  if (state.status === 'error') return <Alert type="error" showIcon title="Could not load this trip's arrivals and departures." />;
  if (state.crossings.length === 0) return <p className="text-sm text-muted">No arrivals recorded</p>;
  return (
    <ul className="flex flex-col gap-1.5">
      {state.crossings.map((crossing) => (
        <li key={crossing.id} className="flex flex-wrap items-center gap-x-3 text-sm">
          <Tag className="m-0" color={crossing.kind === 'enter' ? 'success' : 'default'}>
            {CROSSING_KIND_LABELS[crossing.kind]}
          </Tag>
          <span className="font-medium text-fg">{crossing.zoneName}</span>
          <time className="text-xs text-muted" dateTime={crossing.deviceTime}>
            {new Date(crossing.deviceTime).toLocaleString()}
          </time>
        </li>
      ))}
    </ul>
  );
}
